import { Box } from '@mui/material';
import tokenLoginPlugin from 'common/plugins/token-login-plugin/tokenLoginPluginCreator';
import { createBrowserHistory, type BrowserHistory } from 'history';
import { RouterProvider } from 'react-router';

import Root from './Root';
import { router } from './Router';

const App = () => {
  const history: BrowserHistory = createBrowserHistory();
  const sessionPlugins = [tokenLoginPlugin(history.location.hash)];

  const height = '100%';

  return (
    <>
      <style>
        {`
          body {
            height: ${height};
          }
          html {
            height: ${height};
          }
          #root {
            height: ${height};
          }
        `}
      </style>
      <Box sx={{ minHeight: '100svh', height }}>
        <Root sessionPlugins={sessionPlugins}>
          <RouterProvider router={router} />
        </Root>
      </Box>
    </>
  );
};

export default App;
